// 基础组件
import SvgIcon from './SvgIcon.vue'; // svg组件
import UploadImg from './uploadImg.vue'; // svg组件
import headerTitle from './headerTitle.vue';
import tideCombination from "./combination.vue";
import capture from "./capture.vue";
export default [
    SvgIcon,
    UploadImg,
    headerTitle,
    tideCombination,
    capture
];



// WEBPACK FOOTER //
// ./src/base/index.js